import React, { useState, useEffect } from 'react';
import { Table, Button } from 'react-bootstrap';
import TablePaginationBar from '../components/TablePaginationBar';
import { BsThreeDots } from 'react-icons/bs';
import { useData } from '../context/DataContext';
import useFetchData from '../hooks/useFetchData';
import { config } from '../config/config';
import { getopensupportrequests } from '../config/url';
import { Link } from 'react-router-dom';
import formatDate from '../utils/formatDate';

const OpenSupportRequests = () => {
  const [render, setRender] = useState(null);
  const [currentRequests, setCurrentRequests] = useState(null);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('');
  const [filteredRequests, setFilteredRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [requestsPerPage, setRequestsPerPage] = useState(10);

  const supportRequests = useFetchData(getopensupportrequests, config);

  useEffect(() => {
    if (supportRequests) {
      let filtered = supportRequests;

      if (filter === 'Sort by Date') {
        filtered = supportRequests.sort((a, b) => {
          const dateA = new Date(a.creationDate);
          const dateB = new Date(b.creationDate);
          return dateA - dateB;
        });
      }

      if (search) {
        filtered = filtered.filter((request) =>
          Object.values(request)
            .join(' ')
            .toLowerCase()
            .includes(search.toLowerCase())
        );
      }

      setFilteredRequests(filtered);
      setRender(Math.floor(Math.random() * 10));
    }
  }, [search, filter, supportRequests]);

  useEffect(() => {
    const indexOfLastRequest = currentPage * requestsPerPage;
    const indexOfFirstRequest = indexOfLastRequest - requestsPerPage;
    setCurrentRequests(
      filteredRequests.slice(indexOfFirstRequest, indexOfLastRequest)
    );
  }, [currentPage, filteredRequests, requestsPerPage, render]);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <div>
      <h2 className='my-4'>Open Support Requests</h2>
      {supportRequests != null ? (
        <>
          <div className='d-flex justify-content-end align-items-center my-3'>
            <div className='me-2'>
              <input
                type='text'
                className='form-control rounded'
                placeholder='Search by type'
                style={{ maxWidth: '300px' }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            <div>
              <select
                className='form-select'
                value={filter}
                onChange={(e) => setFilter(e.target.value)}
              >
                <option value=''>Select Filter</option>
                <option vlaue='Sort by Date'>Sort by Date</option>
              </select>
            </div>
          </div>
          <div className='bg-white my-4 rounded shadow'>
            <table className='table' responsive='xl' striped bordered hover>
              <thead>
                <tr>
                  <th>Request Date</th>
                  <th>Type</th>
                  <th>User</th>
                  <th>Provider</th>
                  <th>Close Request</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentRequests.map((request) => (
                  <tr key={request._id}>
                    <td>{formatDate(request.createdAt)}</td>
                    <td>{request.requestType}</td>
                    <td>
                      {request.user.firstName}
                      {' ' + request.user.lastName}
                    </td>
                    <td>
                      {request.specialistId.firstName}
                      {' ' + request.specialistId.lastName}
                    </td>
                    <td>{request.closeRequest}</td>
                    <td>
                      <Link to='/support-requests/details'>
                        <Button variant='secondary' size='md'>
                          <BsThreeDots />
                        </Button>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <h4 className='h4 mt-4 mb-4'>Fetching data...</h4>
      )}
      <TablePaginationBar
        currentPage={currentPage}
        totalItems={filteredRequests.length}
        rowsPerPage={requestsPerPage}
        onPageChange={paginate}
        onRowsPerPageChange={(n) => {
          setRequestsPerPage(n);
          setCurrentPage(1);
        }}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </div>
  );
};

export default OpenSupportRequests;
